//@ts-nocheck
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "../../Components/Loader";
@customElement("health-status")
export class HealthCheck extends formElementMixin(LitElement) {
  constructor() {
    super();
  }
  render() {
    return html`
      <div id="healthBg"><pre style="word-wrap: break-word; white-space: pre-wrap;">Healthy</pre></div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "health-status": HealthCheck;
  }
}
